import COLOR from 'constants/color';
import { EMPTY_STRING } from 'constants/general';
import {
  Attributes,
  DetailedHTMLProps,
  InputHTMLAttributes,
  useId
} from 'react';

interface Props
  extends DetailedHTMLProps<
      InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    Attributes {
  id?: string;
  text?: string | JSX.Element;
  dims?: string;
  inputStyles?: string;
  iconStyles?: string;
  icon?: JSX.Element;
}

const CheckBox = ({
  id,
  dims = 'min-w-7 ~w-7/8 min-h-7 ~h-7/8',
  text = EMPTY_STRING,
  className = 'inline-flex items-center ~gap-1/2 cursor-pointer',
  inputStyles = '~text-xs/base text-gray-700',
  iconStyles,
  icon,
  ...rest
}: Props) => {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <label className={className} htmlFor={inputId}>
      <input id={inputId} type='checkbox' className='peer sr-only' {...rest} />
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill={COLOR.WHITE}
        viewBox='0 0 24 24'
        className={`${dims} border sm:border-[0.094] p-[0.031rem] border-primary-200 rounded bg-white dark:bg-gray-50 peer-checked:bg-primary-400 peer-checked:border-primary-400 flex items-center justify-center transition disabled:border-gray-500 disabled:bg-gray-300 shadow-sm`}>
        <g id='SVGRepo_iconCarrier'>
          <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'></path>
        </g>
      </svg>
      {text ? (
        <span className={`text-black dark:text-white ${inputStyles}`}>
          {icon ? <span className={iconStyles}>{icon}</span> : null}
          {text}
        </span>
      ) : null}
    </label>
  );
};

export default CheckBox;
